export enum CONFIG_NAME {
  JUMP = 'jump',
  STRIPE = 'stripe',
  PROGRESS = 'progress',
  MAINTENANCE = 'maintenance',
  GENERAL = 'general',
  TTS = 'textToSpeech',
  REPORT = 'report',
}
